// The frame for a whole screen of prose — the rules document, the admin pages,
// the front door's longer panels.
//
// **A page scrolls and the game does not**, which is the one decision here:
// `index.html` gives `#root` `height: 100%; overflow: hidden` for a full-window
// canvas, so a page has to carry its own scroll. That means `height: 100%`,
// never `min-height: 100vh` — a block whose height is its content has nothing
// to scroll, so a column taller than the window overflowed `#root` and the
// bottom of it was simply unreachable (measured on the front door at U9:
// 1205px of cards in a 720px root, the footer below the fold and no way down).

import { styled } from "@mui/material/styles";

export const Page = styled("div")(({ theme }) => ({
  height: "100%",
  background: theme.kit.color.ground,
  color: theme.kit.color.ink,
  fontFamily: theme.kit.font.body,
  overflowY: "auto"
}));

export interface PageColumnOwnProps {
  /** px. The measure, not the viewport — prose stops being readable past it. */
  width?: number;
}

export const PageColumn = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "width"
})<PageColumnOwnProps>(({ theme, width = 880 }) => ({
  maxWidth: width,
  margin: "0 auto",
  padding: theme.kit.space.xl,
  [`@media (max-width: ${theme.kit.breakpoint.tablet}px)`]: {
    padding: theme.kit.space.lg
  }
}));

export const PageTitle = styled("h1")(({ theme }) => ({
  fontFamily: theme.kit.font.heading,
  fontWeight: 400,
  fontSize: 28,
  lineHeight: 1.1,
  color: theme.kit.color.ink,
  margin: `0 0 ${theme.kit.space.lg}px`
}));
